import React from 'react'
import { Loader } from 'semantic-ui-react'

const LoaderExampleInlineCentered = () => <Loader active inline='centered' />

export default LoaderExampleInlineCentered
